/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

const Params = z.strictObject({ requestId: z.string().min(1) });

export const JiraRequestGet = {
  id: 'jira-types.get',
  tag: 'Support',
  summary: 'Jira types',
  description: 'Get jira types',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/jira/request/${params.requestId}`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.any(),
        },
      },
    },
  },
} as const satisfies Endpoint;
